module.exports = __webpack_public_path__ + "img/cellDestruction.d71f6626.gif";